export const loadList = list => ({
  type: 'LOAD_LIST',
  list,
});

export const foldTitle = folded => ({
  type: 'FOLD_TITLE',
  folded,
});
